import { render } from "./CereriConcediu.vue?vue&type=template&id=ed9ca942&ts=true"
import script from "./CereriConcediu.vue?vue&type=script&lang=ts"
export * from "./CereriConcediu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__